/**
 * hajack document.readyState
 */
export default function hijackReadyState() {
    let readyState: 'loading' | 'interactive' | 'complete' = 'loading';

    Object.defineProperty(document, 'readyState', {
        get() {
            return readyState;
        },
        configurable: true,
    });

    return {
        complete() {
            readyState = 'complete';
        },
        free() {
            Object.defineProperty(document, 'readyState', {
                configurable: true,
            });
        },
        interactive() {
            readyState = 'interactive';
        }
    }
}